import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { DadosRenunciar } from "src/app/model/dados-renunciar";
import { ValoresCalculadosRenuncia } from "src/app/model/valores-calculados-renuncia";
import { ApuracaoRenunciaDto, JanelaRenunciaResponseDto, Renuncia, RenunciaDetalheDto, ValorDistribuicaoAgenteFinanceiroApuracaoRenuncia } from "src/app/model/renuncia.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

@Injectable({
    providedIn: 'root'
})
export class RenunciaService extends FgiBackEndService<Renuncia> {

    getNewEntity() {
        return new Renuncia();
    }

    protected getResourceURL(): string {
        return 'front/renuncia';
    }

    getJanelaAtiva(): Observable<JanelaRenunciaResponseDto> {
        return this.http.get(`${this.BASE_URL}/janela-ativa`).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenunciaResponseDto>;
    }

    getRenunciasDetalhe(id?: number): Observable<RenunciaDetalheDto[]> {
        let params = new HttpParams();
        if (id) {
            params = params.append('idAgente', id);
        } else {
            params = params.append('idAgente', -1);
        }
        return this.http.get(`${this.BASE_URL}/renuncias-detalhe`, { params: params }).pipe(
            catchError((e) => this.handleError(e))) as Observable<RenunciaDetalheDto[]>;
    }

    getApurarRenuncias(): Observable<ApuracaoRenunciaDto[]> {
        return this.http.get(`${this.BASE_URL}/apurar`).pipe(
            catchError((e) => this.handleError(e))) as Observable<ApuracaoRenunciaDto[]>;
    }

    getRenuncias(id?: number): Observable<Renuncia[]> {
        let params = new HttpParams();
        if (id) {
            params = params.append('idAgente', id);
        } else {
            params = params.append('idAgente', -1);
        }
        return this.http.get(`${this.BASE_URL}/renuncias`, { params: params }).pipe(
            catchError((e) => this.handleError(e))) as Observable<Renuncia[]>;
    }

    getDadosRenunciar(): Observable<DadosRenunciar> {
        return this.http.get(`${this.BASE_URL}/dados-renunciar`).pipe(
            catchError((e) => this.handleError(e))) as Observable<DadosRenunciar>;
    }

    salvar(cnpjAgente: string, dados: DadosRenunciar): Observable<any> {
        return this.http.post(`${this.BASE_URL}/${cnpjAgente}`, dados).pipe(
            catchError((e) => this.handleError(e)));
    }

    excluirRenuncias(ideRenuncia?: number): Observable<Renuncia[]> {
        let params = new HttpParams();
        params = params.append('ideRenuncia', ideRenuncia);

        return this.http.post(`${this.BASE_URL}/excluir`, { params: params }).pipe(
            catchError((e) => this.handleError(e))) as Observable<Renuncia[]>;
    }

    calcularValores(valorRenunciar: number): Observable<ValoresCalculadosRenuncia> {
      let params = new HttpParams();
      params = params.append('valorRenunciar', valorRenunciar);
      return this.http.get(`${this.BASE_URL}/calcular-renunciar`, { params: params }).pipe(
          catchError((e) => this.handleError(e))) as Observable<ValoresCalculadosRenuncia>;
    }

    getExistenciaApuracaoRenunciasPorTranche(ideAgenteFinanceiro?: number, ideTranche?: number): Observable<ApuracaoRenunciaDto> {
        let params = new HttpParams();
        if (ideAgenteFinanceiro) {
            params = params.append('ideAgenteFinanceiro', ideAgenteFinanceiro);
        }
        if (ideTranche) {
            params = params.append('ideTranche', ideTranche);
        }
        return this.http.get<ApuracaoRenunciaDto>(`${this.BASE_URL}/existencia-apuracao`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<ApuracaoRenunciaDto>;
    }


    getExistenciaApuracaoRenunciasPorModalidade(): Observable<Number> {
        return this.http.get(`${this.BASE_URL}/existencia-apuracao-modalidade`).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

    getValoresApuracaoDistribuidos(): Observable<ValorDistribuicaoAgenteFinanceiroApuracaoRenuncia> {
        return this.http.get(`${this.BASE_URL}/valores-apuracao-distribuido`).pipe(
            catchError((e) => this.handleError(e))) as Observable<ValorDistribuicaoAgenteFinanceiroApuracaoRenuncia>;
    }

    getApuracaoRenunciasDetalhe(id?: number): Observable<ApuracaoRenunciaDto> {
        return this.http.get(`${this.BASE_URL}/existencia-apuracao-janela`).pipe(
            catchError((e) => this.handleError(e))) as Observable<ApuracaoRenunciaDto>;
    }

}
